<template>
    <transition v-if="isVisible">
        <div class="color-filter" :class="[bemAdd(cssName)]"/>
    </transition>
</template>

<script>
    // This file will be used only for the easter eggs
    import { mapState } from 'vuex';
    import bemFacets from '@dreipol/vue-ui/src/mixins/bem';

    export default {
        mixins: [bemFacets('color-filter')],
        computed: {
            ...mapState('easter-egg', ['name']),
            isVisible() {
                return this.name;
            },
            cssName() {
                return this.name.replace(/\s/g, '-');
            },
        },
    };
</script>
